module.exports = __webpack_public_path__ + "img/27.a41892bb.png";